import { VMediumDutiesFormTypeComboBoxComponent } from './vmedium-duties-form-type-combo-box.component';
import { PlessViewUtilsSub } from '../../../kymw00/pless-view-utils-sub.service';
import { VMediumDutiesForm } from './vmedium-duties-form.model';

/**
 * 共通部品　業態別媒体区分コンボボックスを制御するクラス
 *
 * @export VMediumDutiesFormTypeComboBoxModel
 * @class VMediumDutiesFormTypeComboBoxModel
 */
export class VMediumDutiesFormTypeComboBoxModel {

  // 業態別媒体区分リスト
  public mediumList: VMediumDutiesForm[];
  // 先頭空白表示
  public blank: boolean = <boolean>true;
  // コンボボックスインスタンス
  public component: VMediumDutiesFormTypeComboBoxComponent;
  // コードリスト取得完了
  public completeUpdateFlg: boolean = <boolean>false;
  // 初期設定コード値
  public setMediumType: string = <string>'';

  public allMediumType: boolean = <boolean>false;
  // 初期データ自動取得フラグ
  public initAutoLoad: boolean = <boolean>true;
  // オーダーコード(voの値)
  public orderCode: string = <string>'';


  /**
   * 媒体区分を更新する
   *
   * @param {*} serverData 媒体区分のサーバ取得データ
   * @returns {void}
   * @memberof VMediumDutiesFormTypeComboBoxModel
   */
  public updateMediumList(serverData: VMediumDutiesForm[]): void {
    let tempDataList: VMediumDutiesForm[] = [];

    if (serverData !== null) {
      tempDataList = serverData;

      if (PlessViewUtilsSub.isEmptyArray(tempDataList)) {
        tempDataList = [];
      }
    }

    // 処理件数
    let index: number = <number>0;

    // 先頭空白追加
    if (this.blank) {
      const ob: VMediumDutiesForm = new VMediumDutiesForm();
      tempDataList.splice(index, 0, ob);
      index = 1;
    }
    // 全媒体
    if (this.allMediumType) {
      const ob2: VMediumDutiesForm = new VMediumDutiesForm();
      ob2.MediumName = '全媒体',
      ob2.MediumTypeName = '*:全媒体',
      tempDataList.splice(index, 0, ob2);
      index += 1;
    }

    // コード+：+名称追加
    for (; index < tempDataList.length; index++) {
      tempDataList[index].MediumTypeName = tempDataList[index].MediumType + ':' + tempDataList[index].MediumName;
    }

    this.mediumList = tempDataList;

    this.completeUpdateFlg = true;
    this.component.updateSelectedMediumType();

  }

}
